import { ReactNode, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectCurrentUser } from '@/redux/auth/auth.slice';
import { setShowLoginDialog } from '@/redux/global/global.slice';

function PrivateRoute({ children }: { children: ReactNode }) {
  const { user, isAuthenticated, isLoading } = useSelector(selectCurrentUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      navigate('/');
      dispatch(setShowLoginDialog(true));
    }
    if (!user) {
      navigate('/');
      dispatch(setShowLoginDialog(true));
    }
  }, [user, isAuthenticated, isLoading, navigate, dispatch]);

  return children;
}

export default PrivateRoute;
